import { type AggregationFn } from "@tanstack/react-table";

import { isComparableNumber, round } from "./aggregationFnUtils";

export const max: AggregationFn<unknown> = (columnId, leafRows, _immediateChildRows) => {
	let max: number | undefined;

	// NOTE: If we ever support nested columns, we might want to `max` the `immediateChildRows` of
	// this grouping, since they'll have aggregated their own children.
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (isComparableNumber(value) && (max === undefined || max < value)) {
			max = value;
		}
	});

	if (max === undefined) {
		return null;
	}

	return round(max);
};
